import {
    API
} from '../Api.class';
import {
    ProfileAPI
} from './Profile.api';


export class UserAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

        this.ProfileAPI = new ProfileAPI(baseUrl);
    }


    async list(pagination, filter, meta) {
        this.loading = true

        return await this.__axiosInstance.get('api/v1/users', {
            meta,
            params: {
                ...pagination,
                ...filter
            }
        })

    }

    async get(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/users/${id}`, {
            meta
        });

    }


    async create(body, meta) {
        this.loading = true;

        return await this.__axiosInstance.post('api/v1/users', body, {
            meta
        });
    }


    async update(user, meta) {
        this.loading = true

        return await this.__axiosInstance.put(`api/v1/users/${user.id}`, user, {
            meta
        });
    }

    async delete(user, meta) {
        this.loading = true

        return await this.__axiosInstance.delete(`api/v1/users/${user.id}`, {
            meta
        });
    }
}